"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _twoDecimalPlaces = _interopRequireDefault(require("./two-decimal-places"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var formattedPrice = function formattedPrice(number) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GBP';
  var price = (0, _twoDecimalPlaces.default)(number);
  return new Intl.NumberFormat(country, {
    style: 'currency',
    currency: currency
  }).format(price).replace(/\s/g, '');
};
var _default = exports.default = formattedPrice;